import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import Ratings from "../Components/Ratings";
import ProfileSections, { ProfileSectionType } from "./ProfileSections";

interface ProfileHeaderProps {
  avatar: React.ReactNode;
  name: string;
  subtext: string;
  bio?: string;
  ratings?: any;
  showRatings?: boolean;
  userId?: number;
  userType: "BA" | "Brand" | "Account";
  currentSection: ProfileSectionType;
  onSectionChange: (section: ProfileSectionType) => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  avatar,
  name,
  subtext,
  ratings,
  showRatings = false,
  userId,
  userType,
  currentSection,
  onSectionChange,
}) => {
  return (
    <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center">
          <Avatar src={avatar as string} sx={{ width: 100, height: 100 }} />
          <Stack spacing={0.5} ml={2}>
            <Typography variant="h5">{name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {subtext}
            </Typography>
            {showRatings && ratings && (
              <Box sx={{ mt: 0.5 }}>
                <Ratings
                  userId={userId!}
                  ratings={ratings}
                  compact={true}
                  sx={{
                    "& .MuiBox-root": {
                      minWidth: "auto",
                      mr: 1.5,
                      px: 0.75,
                      py: 0.25,
                      backgroundColor: "transparent",
                    },
                  }}
                />
              </Box>
            )}
          </Stack>
        </Box>
        <Box sx={{ mt: 3 }}>
          <ProfileSections
            userType={userType}
            currentSection={currentSection}
            onSectionChange={onSectionChange}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default ProfileHeader;
